import React, { useState, useEffect } from 'react';
import './style.scss';
import ENV_CONFIG from '../../../../../../../config/environment';

const EKyc = (props) => {
    const {objectt} = props;
    return (
        <div className='e-kyc-modal'>
            <h3>WELCOME TO HDFC MF FAMILY!</h3>
            <p>Kindly complete your KYC to start your
            investment journey</p>
            <a href={`${ENV_CONFIG.INVESTOR_BASE_URL}/ekyc?prefill=${objectt}`} target="_blank" rel="noreferrer">COMPLETE KYC</a>
        </div>
    );
}

export default EKyc;